// extracted by mini-css-extract-plugin
export default {"usersCount":"Heading_usersCount__ULbPr"};